import {
  CreateScheduledEventRequestDto,
  ScheduledEventDto,
  ScheduledEventViewDto,
  UpdateScheduledEventRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const scheduledEventRequests = {
  getScheduledEvents: EndpointDefinition.get<
    ScheduledEventDto[],
    { userId: string; startEpochTime?: number; endEpochTime?: number }
  >({
    name: 'getScheduledEvents',
    route: '/users/:userId/scheduled-events',
  }),

  getScheduledEventsForGuide: EndpointDefinition.get<
    ScheduledEventViewDto,
    {
      guideId: string;
      startEpochTime?: number;
      endEpochTime?: number;
      includeMemberDetails?: boolean;
    }
  >({
    name: 'getScheduledEventsForGuide',
    route: '/users/:guideId/scheduled-events/guide',
  }),

  createScheduledEventForUser: EndpointDefinition.post<
    ScheduledEventDto,
    CreateScheduledEventRequestDto,
    { userId: string }
  >({
    name: 'createScheduledEventForUser',
    route: '/users/:userId/scheduled-events',
  }),

  updateScheduledEvent: EndpointDefinition.patch<
    ScheduledEventDto,
    UpdateScheduledEventRequestDto,
    { userId: string; scheduledEventId: number }
  >({
    name: 'updateScheduledEvent',
    route: '/users/:userId/scheduled-events/:scheduledEventId',
  }),

  snoozeScheduledEventForUser: EndpointDefinition.post<
    ScheduledEventDto,
    null,
    { userId: string; scheduledEventId: number }
  >({
    name: 'snoozeScheduledEventForUser',
    route: '/users/:userId/scheduled-events/:scheduledEventId/snooze',
  }),

  deleteScheduledEventForUser: EndpointDefinition.delete<
    ScheduledEventDto,
    { userId: string; scheduledEventId: number }
  >({
    name: 'deleteScheduledEventForUser',
    route: '/users/:userId/scheduled-events/:scheduledEventId',
  }),
};
